import { useVersionedContext } from '@backstage/version-bridge';

const useApp = () => {
  const versionedContext = useVersionedContext(
    "app-context"
  );
  if (!versionedContext) {
    throw new Error("App context is not available");
  }
  const appContext = versionedContext.atVersion(1);
  if (!appContext) {
    throw new Error("AppContext v1 not available");
  }
  return appContext;
};

export { useApp };
//# sourceMappingURL=useApp.esm.js.map
